var app = angular.module("leonardo");

var AdminAccountConfirmDialogController = function($scope, AccountService, AccountRequestService, SectorRestService,
                                                   FormErrorsService) {

  $scope.sectorRestService = SectorRestService;

  if (!$scope.isRequest) {
    $scope.data = {
      name: $scope.ngDialogData.account.name ?
        $scope.ngDialogData.account.name.split('Pending account for ').join('') :
        $scope.ngDialogData.account.first_name + ' ' + $scope.ngDialogData.account.last_name,
      sector: $scope.ngDialogData.account.sector ? $scope.ngDialogData.account.sector : ''
    };
  }
  else {
    $scope.data = {
      name: $scope.ngDialogData.account.first_name + ' ' + $scope.ngDialogData.account.last_name,
      sector: ''
    };
  }

  $scope.submit = function() {
    var service = $scope.isRequest ? AccountRequestService : AccountService;
    $scope.Form.$submitted = true;
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    service.activate($scope.ngDialogData.account, $scope.data.sector, $scope.data.name).then(function(data) {
      $scope.confirm(data);
    }, function () {
      $scope.closeThisDialog();
    });
  };

};

app.controller('AdminAccountConfirmDialogController', ['$scope', 'AccountService', 'AccountRequestService',
  'SectorRestService', 'FormErrorsService', AdminAccountConfirmDialogController]);
